import Combine from '../../components/Combine/Combine'
import Waiting from './Waiting'

const WaitList = () => {
  return (
    <Combine    >
    <Waiting/>
    </Combine>
  )
}

export default WaitList
